module.exports = __webpack_public_path__ + "static/productpage-wireframe-278386c329bee9e3c110e10cb492e98c.png";